import { render, staticRenderFns } from "./CorrectWord.vue?vue&type=template&id=17e7c3e2&scoped=true"
import script from "./CorrectWord.vue?vue&type=script&lang=js"
export * from "./CorrectWord.vue?vue&type=script&lang=js"
import style0 from "./CorrectWord.vue?vue&type=style&index=0&id=17e7c3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e7c3e2",
  null
  
)

export default component.exports